import { render } from "./B2bTableMenuSalesReport.vue?vue&type=template&id=7f511aa1&scoped=true&lang=pug"
import script from "./B2bTableMenuSalesReport.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuSalesReport.vue?vue&type=script&lang=js"

import "./B2bTableMenuSalesReport.vue?vue&type=style&index=0&id=7f511aa1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f511aa1"]])

export default __exports__